import { request } from "../../utils/config"
import {
  renewAccessToken,
  renewAccessTokenVariables,
} from "./types/renewAccessToken"

export const RENEW_TOKEN = async (
  data: renewAccessTokenVariables
): Promise<renewAccessToken> => {
  const response = await request({
    url: "AccountAPI/RenewAccessToken",
    data: data,
    method: "POST",
  })
  return response.data
}
